import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e3d21a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "surface-card p-4 shadow-2 border-round" };
const _hoisted_2 = { class: "mb-3 flex flex-column align-items-start md:flex-row md:align-items-center md:justify-content-between" };
const _hoisted_3 = { class: "header-container mb-3 md:mb-0" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-3xl font-medium text-900 mb-3" }, "Finish", -1));
const _hoisted_5 = { class: "surface-card p-4 shadow-2 border-round mb-2" };
const _hoisted_6 = { class: "mb-3 md:mb-0" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-3xl font-medium text-900 mb-3" }, " Your import is processing! ", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "grid formgrid" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Your import request has been queued for processing. We are going to be analyzing your file looking for fraud across a number of data points. Proceed to the import history page to get your full report and analysis.")
], -1));
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImportFinish',
    setup(__props) {
        const importStages = [
            { "stage": "Import File", "icon": "pi pi-circle-fill", "color": "#2196F3" },
            { "stage": "Preview", "icon": "pi pi-circle-fill", "color": "#2196F3" },
            { "stage": "Finish", "icon": "pi pi-circle-fill", "color": "#2196F3" }
        ];
        return (_ctx, _cache) => {
            const _component_Timeline = _resolveComponent("Timeline");
            const _component_Button = _resolveComponent("Button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(_component_Timeline, {
                            value: importStages,
                            layout: "horizontal",
                            align: "center"
                        }, {
                            marker: _withCtx((slotProps) => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(slotProps.item.icon),
                                    style: _normalizeStyle({ color: slotProps.item.color })
                                }, null, 6)
                            ]),
                            content: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.item.stage), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _hoisted_8,
                        _createVNode(_component_Button, {
                            class: "p-button-info",
                            label: "Go to Import History",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push('/analysis-import-history')))
                        })
                    ])
                ])
            ]));
        };
    }
});
